






































import Vue from 'vue'
import { mapState } from 'vuex'
import store from '@/store'
export default Vue.extend({
    name: 'login',
    props: {
        open: Boolean,
    },
    data: () => ({
        showPassword: false,
        email: '',
        password: '',
        toggleError: false,
    }),
    computed: {
        dialogOpen: {
            get() {
                return this.open
            },
            set(open: boolean) {
                if (!open) this.$emit('close')
            },
        },
        ...mapState('user', ['user', 'error']),
    },
    methods: {
        loginSubmit() {
            store
                .dispatch('user/login', {
                    email: this.email,
                    password: this.password,
                })
                .then(() => {
                    if (this.error) {
                        this.toggleError = true
                    } else {
                        this.$emit('close')
                    }
                })
        },
    },
})
